export function EFArrow(props: any) {
    return (
        <svg {...props} width="7px" height="11px" viewBox="0 0 7 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="控件" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="控件/Learn-More-17右箭头" transform="translate(-93.000000, -9.000000)" stroke="#2673FF" strokeWidth="1.5">
                    <g id="路径-2" transform="translate(94.000000, 9.000000)">
                        <polyline
                            transform="translate(0.449747, 5.449747) rotate(-135.000000) translate(-0.449747, -5.449747) "
                            points="-2.55025253 2.44974747 -2.55025253 8.44974747 3.44974747 8.44974747"
                        ></polyline>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export function EFTimer(props: any) {
    // 40*40 #000
    return (
        <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="support" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="产品支持内页-FAQ默认态（手机端）" transform="translate(-28.000000, -724.000000)">
                    <g id="Product-Introduction" transform="translate(28.000000, 724.000000)">
                        <polygon id="路径" points="0 0 40 0 40 40 0 40"></polygon>
                        <g
                            id="编组"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            transform="translate(2.000000, 6.228667)"
                            stroke="currentColor"
                            strokeWidth="1.68"
                        >
                            <path
                                d="M0,0.333333333 L25.8826667,0.333333333 M0,9.63533333 L10.128,9.63533333 M0,18.9366667 L10.128,18.9366667 M0,27.1133333 L18.0053333,27.1133333 M25.802,23.4446667 L22.6746667,23.4446667 C17.9346667,23.4446667 14.0926667,19.6046667 14.0926667,14.868 C14.0926667,10.1313333 17.9346667,6.292 22.6746667,6.292 L25.8013333,6.292 C30.5413333,6.292 34.384,10.1313333 34.384,14.868 C34.384,19.6046667 30.542,23.444 25.802,23.444 L25.802,23.4446667 Z M29.94,22.3813333 L36,28.438"
                                id="形状"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export function EFBattery(props: any) {
    // 40*40 #000
    return (
        <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="support" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="产品支持内页-FAQ默认态（手机端）" transform="translate(-28.000000, -933.000000)">
                    <g id="Troubleshooting" transform="translate(28.000000, 933.000000)">
                        <polygon id="路径" points="0 0 40 0 40 40 0 40"></polygon>
                        <path
                            d="M20.9466667,23.9746667 C20.9466667,24.51 20.5233333,24.9453333 20,24.9453333 C19.4766667,24.9453333 19.0533333,24.51 19.0533333,23.9746667 C19.0533333,23.4386667 19.4766667,23.004 20,23.004 C20.5233333,23.004 20.9466667,23.4386667 20.9466667,23.9746667"
                            id="路径"
                            fill="#000000"
                            fillRule="nonzero"
                        ></path>
                        <path
                            d="M20,15.8313333 L20,21.0926667 M22.1113333,37.3333333 L17.8886667,37.3333333 C8.56066667,37.3333333 1,29.5733333 1,20 C1,10.4273333 8.56066667,2.66666667 17.8886667,2.66666667 L22.1113333,2.66666667 C31.4393333,2.66666667 39,10.4273333 39,20 C39,29.5733333 31.4393333,37.3333333 22.1113333,37.3333333 Z"
                            id="形状"
                            stroke="currentColor"
                            strokeWidth="1.61"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M18.0046667,10.52 L9.31133333,24.008 C8.304,25.5713333 9.396,27.6573333 11.2226667,27.6573333 L28.7773333,27.6573333 C30.6126667,27.6573333 31.704,25.5513333 30.6773333,23.9893333 L21.8146667,10.5026667 C21.3970167,9.85352895 20.6767918,9.46262168 19.9049116,9.46610983 C19.1330314,9.46964491 18.4163931,9.86708909 18.0046667,10.52 L18.0046667,10.52 Z"
                            id="路径"
                            stroke="currentColor"
                            strokeWidth="1.61"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export function EFNote(props: any) {
    return (
        <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="support" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="产品支持内页-FAQ默认态（手机端）" transform="translate(-54.000000, -845.000000)">
                    <g id="NOTE" transform="translate(54.000000, 845.000000)">
                        <polygon id="路径" points="0 0 40 0 40 40 0 40"></polygon>
                        <path
                            d="M28.8706667,33.3646667 C28.8706667,33.9246667 28.4193333,34.378 27.8626667,34.378 C27.3053333,34.378 26.854,33.9246667 26.854,33.3646667 C26.854,32.806 27.3053333,32.3513333 27.8626667,32.3513333 C28.4193333,32.3513333 28.8706667,32.806 28.8706667,33.3646667"
                            id="路径"
                            fill="#000000"
                            fillRule="nonzero"
                        ></path>
                        <path
                            d="M27.8626667,24.864 L27.8626667,30.356 M7.65933333,9.57933333 L23.5333333,9.57933333 M7.65933333,16.502 L15.5973333,16.502 M29.4246667,38 L26.3,38 C21.564,38 17.7253333,34.1386667 17.7253333,29.3753333 C17.7253333,24.612 21.564,20.7506667 26.3,20.7506667 L29.4246667,20.7506667 C34.1613333,20.7506667 38,24.612 38,29.3753333 C38,34.1386667 34.1613333,38 29.4246667,38 Z"
                            id="形状"
                            stroke="currentColor"
                            strokeWidth="1.68"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                        <path
                            d="M27.2533333,38 L6.498,38 C4.014,38 2,35.9746667 2,33.476 L2,6.524 C2,4.02533333 4.01333333,2 6.498,2 L27.2526667,2 C29.7366667,2 31.7506667,4.02533333 31.7506667,6.524 L31.7506667,21.0746667"
                            id="路径"
                            stroke="currentColor"
                            strokeWidth="1.68"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
